module.exports = __webpack_public_path__ + "img/xinxiang.2968038c.png";